import { css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { Page } from "../enums/Page";

const styles: string = css`
#miniGame {
   padding: 20px;
   background-color: #1e1a16;
   border-radius: 10px;
   border: 1px solid #5c4934;
   max-width: 500px;
   margin: 0 auto;
   height: 2.5rem;
   display: flex;
   flex-direction: column;


}


h3 {
   text-align: center;
   color: #ffffff;
   margin-top: 0;
}


.minigame-group {
   display: flex;
   flex-direction: column;
   gap: 20px;
}


.choices {
   display: flex;
   justify-content: center;
   gap: 15px;
}


.choice-btn {
   padding: 5px 10px;
   background-color: #d6a34a;
   border: 1px solid #5c4934;
   color: #1a1008;
   cursor: pointer;
   font-size: inherit;
   text-transform: uppercase;
   user-select: none;
   font-family: inherit;
   font-size: inherit;
}


.choice-btn:hover,
.choice-btn.active {
   background-color: #a96f2d;
   color: #fffbea;
}


.status {
   text-align: center;
   font-size: 18px;
   margin: 15px 0;
   color: #ffffff;
}


.scoreboard {
   display: flex;
   justify-content: space-around;
   margin-bottom: 15px;
   font-size: 18px;
   color: #fffbea;
   height: 0.3rem ;
}


.result {
   text-align: center;
   font-weight: bold;
   font-size: 20px;
   margin-top: 15px;
   color: #fffbea;
   height: 0.5rem;
}


.game-over {
   text-align: center;
   font-size: 20px;
   font-weight: bold;
   color: #e91e63;
   margin-top: 20px;
}




.choices-display {
   display: flex;
   justify-content: space-around;
   margin: 15px 0;
}


.choice-display {
   font-size: 24px;
   text-align: center;
   color: #fffbea;
}


`;

enum Choice {
    ROCK = "rock",
    PAPER = "paper",
    SCISSORS = "scissors",
}

export class MiniGameComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    private playerScore: number = 0;
    private snakeScore: number = 0;
    private gameOver: boolean = false;
    private roundResult: string = "";
    private playerChoice: Choice | null = null;
    private snakeChoice: Choice | null = null;

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();

        // Get the quest game state when component connects
        void this._gameRouteService.getQuestGameState().then(questState => {
            console.log("Quest game state:", questState);
        });
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }
        const element: HTMLElement = this.renderMiniGame();
        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }
        this.shadowRoot.appendChild(element);
        this.handleDOMContent();
    }

    private renderMiniGame(): HTMLElement {
        const element: HTMLElement = document.createElement("div");

        element.innerHTML = `
           <style>
               ${styles}
           </style>
          
           <div id="miniGame">
               <h3>Rock Paper Scissors</h3>
              
               <div class="minigame-group">
                   <div class="scoreboard">
                       <div>You: <span id="playerScore">${this.playerScore}</span></div>
                       <div>Snake: <span id="snakeScore">${this.snakeScore}</span></div>
                   </div>
                  
                   <div class="choices-display" id="choicesDisplay">
                       <div class="choice-display" id="playerChoiceDisplay">
                           ${this.playerChoice ? this.getEmojiForChoice(this.playerChoice) : "?"}
                       </div>
                       <div class="choice-display">vs</div>
                       <div class="choice-display" id="snakeChoiceDisplay">
                           ${this.snakeChoice ? this.getEmojiForChoice(this.snakeChoice) : "?"}
                       </div>
                   </div>
                  
                   <div class="status" id="statusMessage">
                       ${this.gameOver ? "" : "Choose your move!"}
                   </div>
                  
                   <div class="result" id="roundResult">${this.roundResult}</div>
                  
                   ${this.gameOver
                       ? `<div class="game-over" id="gameOverMessage">
                           ${this.playerScore > this.snakeScore ? "You have won. You may proceed to the next room" : "Snake wins the game!"}
                       </div>
                       `
                       : `<div class="choices" id="choicesButtons">
                           <button class="choice-btn" id="rockBtn">🪨 Rock</button>
                           <button class="choice-btn" id="paperBtn">📄 Paper</button>
                           <button class="choice-btn" id="scissorsBtn">✂️ Scissors</button>
                       </div>`
                   }
               </div>
           </div>
       `;

        return element;
    }

    private handleDOMContent(): void {
        if (!this.shadowRoot) return;

        if (!this.gameOver) {
            const rockBtn: HTMLElement | null = this.shadowRoot.getElementById("rockBtn");
            const paperBtn: HTMLElement | null = this.shadowRoot.getElementById("paperBtn");
            const scissorsBtn: HTMLElement | null = this.shadowRoot.getElementById("scissorsBtn");

            if (rockBtn) rockBtn.addEventListener("click", () => this.playRound(Choice.ROCK));
            if (paperBtn) paperBtn.addEventListener("click", () => this.playRound(Choice.PAPER));
            if (scissorsBtn) scissorsBtn.addEventListener("click", () => this.playRound(Choice.SCISSORS));
        }
        else {
            // const resetBtn: HTMLElement | null = this.shadowRoot.getElementById("resetBtn");
            // if (resetBtn) resetBtn.addEventListener("click", () => this.resetGame());
        }
    }

    private playRound(playerChoice: Choice): void {
        this.playerChoice = playerChoice;
        this.snakeChoice = this.getSnakeChoice();

        const result: "win" | "lose" | "tie" = this.determineWinner(this.playerChoice, this.snakeChoice);

        if (result === "win") {
            this.playerScore++;
            this.roundResult = "You win this round!";
        }
        else if (result === "lose") {
            this.snakeScore++;
            this.roundResult = "Snake wins this round!";
        }
        else {
            this.roundResult = "It's a tie!";
        }

        // Check if game is over (someone reached 3 points)
        if (this.playerScore >= 3 || this.snakeScore >= 3) {
            this.gameOver = true;
            const isPlayerWinner: boolean = this.playerScore > this.snakeScore;

            // Create a custom event with proper type
            const customEvent: CustomEvent<{ winner: "player" | "snake" }> = new CustomEvent("miniGameCompleted", {
                detail: {
                    winner: isPlayerWinner ? "player" : "snake",
                },
                bubbles: true,
                composed: true,
            });

            // Dispatch the event from this component
            this.dispatchEvent(customEvent);

            // If snake wins, handle game over
            if (!isPlayerWinner) {
                // Add a small delay to make sure the game over screen is visible before navigating
                setTimeout(() => {
                    this.handleGameOver();
                }, 1500);
            }
        }

        this.render();
    }

    private handleGameOver(): void {
        // Get the quest game state before handling game over
        void this._gameRouteService.getQuestGameState().then(questState => {
            console.log("Quest game state at game over:", questState);

            // Als de speler verliest, switch naar de Canvas-pagina
            if (this.playerScore < this.snakeScore) {
                this._gameEventService.switchPage(Page.Canvas);
            }
        });
    }

    private getSnakeChoice(): Choice {
        const choices: Choice[] = [Choice.ROCK, Choice.PAPER, Choice.SCISSORS];
        const randomIndex: number = Math.floor(Math.random() * choices.length);
        return choices[randomIndex];
    }

    private determineWinner(playerChoice: Choice, snakeChoice: Choice): "win" | "lose" | "tie" {
        if (playerChoice === snakeChoice) {
            return "tie";
        }

        if (
            (playerChoice === Choice.ROCK && snakeChoice === Choice.SCISSORS) ||
            (playerChoice === Choice.PAPER && snakeChoice === Choice.ROCK) ||
            (playerChoice === Choice.SCISSORS && snakeChoice === Choice.PAPER)
        ) {
            return "win";
        }

        return "lose";
    }

    // private resetGame(): void {
    //     this.playerScore = 0;
    //     this.snakeScore = 0;
    //     this.gameOver = false;
    //     this.roundResult = "";
    //     this.playerChoice = null;
    //     this.snakeChoice = null;

    //     // Get quest state when resetting the game
    //     void this._gameRouteService.getQuestGameState().then(questState => {
    //         console.log("Quest game state on reset:", questState);
    //     });

    //     this.render();
    // }

    private getEmojiForChoice(choice: Choice): string {
        switch (choice) {
            case Choice.ROCK: return "🪨";
            case Choice.PAPER: return "📄";
            case Choice.SCISSORS: return "✂️";
        }
    }
}
